import { CSSObject } from "styled-components";
import { vfxTheme } from "../../components/common/VFX-UI/Theme/theme";

interface LayoutStyles {
    sidebarItem: CSSObject;
    
}

export const useLayoutStyles = (): LayoutStyles => {
    return {
        sidebarItem: {
            fontFamily: vfxTheme.typography.fontFamily,
            color: vfxTheme.palette.text.secondary,
            fontSize: "1.25em",
            textTransform: "none"
        },
    };
};
